export default class BaseUrl {
  ApiBAseURL = "/auth";
}
